<template>
    <section id="shadesWrapper" style="top: 0px; right: 0px;">
        <div id="contentMenu" class="fright full">
            <div id="searchInputWrapper" class="flexContainer ai-c jc-sb">
                <input id="searchInput" class="full" type="search" v-model="search" :placeholder="$t('common.search')" @keyup="searchShade" />
                <div class="ai-c">
                    <img
                        id="cross"
                        src="../../../assets/cross.png"
                        alt=""
                        width="10"
                        height="10"
                        class="cross pointer"
                        @click="reset"
                        v-if="search !== ''"
                    />
                </div>
                <div class="ai-c"><img @click="searchShade" class="pointer" id="glass" src="../../../assets/loupe.png" /></div>
            </div>
            <div id="filtersShades" class="rel">
                <ul id="relatedProducts" class=" flexContainer jc-sb">
                    <li
                        class="rel flexContainer jc-c pointer uppercase iBlock"
                        v-for="(product, index) in products"
                        :key="product.id"
                        @click="activeProduct(index, product.id);"
                        :class="{ active: productActive === index }"
                    >
                        <span>{{ product.terms.name[$t("trad")]["value"] }}</span>
                    </li>
                </ul>
                <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
                    <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
                </div>
                <div v-if="relProductId === undefined">
                    <p>{{ noShades }}</p>
                </div>
                <section id="shadesContent" class="scrollY"></section>
            </div>
        </div>
    </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { stateMixin } from "./../mixins/state";
import { utilsMixin } from "./../mixins/utils";
//    import { builderMixin } from '../mixins/builder.js'
//    import { groupEditorMixin } from '../mixins/groupeditor'
import { componentMixin } from "../mixins/component";
import { bus } from "../../../main";
import { i18n } from "../../../main.js";
import Spinner from "vue-simple-spinner";
import Globals from "../../globals";

const d3 = require("d3");
export default {
    mixins: [stateMixin, utilsMixin, componentMixin],
    data: () => ({
        routeParams: {},
        searchResults: [],
        search: "",
        to: {},
        from: {},
        copyItem: false,
        circleClone: null,
        shades: [],
        idModule: null,
        productActive: 0,
        relatedProducts: [],
        products: {},
        relProductId: null,
        noShades: "",
        loading: true
    }),
    components: {
        Spinner
    },
    watch: {
        retRelatedProduct: function(val) {
            this.loadShades(this.relProductId);
        },
        $route(to, from) {
            this.to = to;
            this.from = from;
            if (this._.size(to.query) === 0) {
                this.clearFilters();
            }
            this.updateQuery(to);
        },
        loading() {
            if (this.loading) {
            }
        }
    },
    methods: {
        ...mapActions("events/planomassmarket", {
            dispatchDragEndShadeColor: "dispatchDragEndShadeColor"
        }),

        displayShade() {
            let self = this;
            this._.forEach(this.filteredShades, function(color, key) {
                let ty = 40 + 60 * key;
                let x = 40;
                let data = { x: x, y: ty, color: color, it: key };
                d3.select("#shadesContent")
                    .append("div")
                    .attr("class", "size1of5 iBlock")
                    .attr("style", "padding:10px 0;")
                    .append("p")
                    .data([data])
                    .attr("style", "background:" + color.color + ";")
                    .attr("class", "grab shadeCircle")
                    .on("mousedown", function(d, i, cmps) {
                        let shade = d3.select(this);
                        shade.classed("selected", function(d, i) {
                            d3.selectAll("p.selected").classed("selected", false);
                            return !d3.select(this).classed("selected");
                        });
                        let data = self.assign(d);
                        let size = cmps[i].getBoundingClientRect();
                        //                                console.log(size)
                        let clone = cmps[i].cloneNode(true);
                        clone.style.position = "absolute";
                        clone.style.left = size.x + "px";
                        clone.style.top = size.y + "px";
                        clone.style.zIndex = 200;
                        clone.style.borderWidth = "1px";
                        document.querySelector("#builderWrapper").appendChild(clone);
                        self.circleClone = clone;
                        d3.select(clone)
                            .data([data])
                            .call(
                                d3
                                    .drag()
                                    .on("start", self.dragStart)
                                    .on("drag", self.dragging)
                                    .on("end", self.dragEnd)
                            );
                        let init = {
                            bubbles: true,
                            cancelable: true,
                            view: window
                        };
                        let evt = new MouseEvent("mousedown", init);
                        clone.dispatchEvent(evt);
                    });
                d3.selectAll("#shadesContent")
                    .append("p")
                    .text(color.ref + " - " + (color.name !== undefined ? color.name : color.nameBis))
                    .attr("style", "font-size:1.4rem;margin:0px;top:-25px")
                    .attr("class", "uppercase size4of5 iBlock rel")
                    .append("p")
                    .text(color.refClient)
                    .attr("class", "refClient");
            });
        },
        loadShades(idProduct) {
            this.relProductId = idProduct;
            this.loading = true;
            if (this.relProductId === undefined) {
                this.loading = false;
            } else {
                this.$store.dispatch("plano/data/getRelatedShades", { id: this.relProductId }).then(() => {
                    let shade;
                    this.getRelatedShades.sort((shade1, shade2) => {
                        return shade1.properties.reference.client_ref1.value - shade2.properties.reference.client_ref1.value;
                    });
                    for (let j in this.getRelatedShades) {
                        shade = this.getRelatedShades[j];
                        this.shades.push({
                            color: Globals.getValueObject(shade, "properties.colors.color.value", ""),
                            id: shade.id,
                            name: shade.name,
                            nameBis: shade.name,
                            ref: Globals.getValueObject(shade, "properties.number.numb1.value", ""),
                            refClient: Globals.getValueObject(shade, "properties.reference.client_ref1.value", "")
                        });
                    }
                    this.shades.unshift({
                        color: "transparent",
                        id: null,
                        name: "NO COLOR",
                        nameBis: "NO COLOR",
                        ref: "0",
                        refClient: " "
                    });
                    this.displayShade();
                    this.loading = false;
                });
            }
        },
        dragStart(d, i, cmps) {},
        dragging(d, i, cmps) {
            let img = cmps[i];
            // faire fonction (img position - scrollTop)
            let sizeContentMod = img.getBoundingClientRect();
            img.style.left = d3.event.sourceEvent.clientX - sizeContentMod.width / 2 + "px";
            img.style.top = d3.event.sourceEvent.clientY - sizeContentMod.height / 2 + "px";
        },
        dragEnd(d, i, cmps) {
            let self = this;

            let path = null;
            if (document.elementsFromPoint) {
                let ar = document.elementsFromPoint(d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
                let nodeTmp;
                for (let i = 0, l = ar.length; i < l; i++) {
                    nodeTmp = ar[i];
                    if (nodeTmp.nodeName === "path") {
                        path = nodeTmp;
                        break;
                    }
                }
            } else {
                path = this.elementFromPoint("path", d3.event.sourceEvent.pageX, d3.event.sourceEvent.pageY);
            }

            if (this.isNewPlano) {
                if (path !== null) this.dispatchDragEndShadeColor({ elt: path, data: d.color });
            } else {
                let node = path !== null ? path.parentNode : null;
                let g = null;
                if (node !== null && (node.nodeName === "g" && self._.startsWith(node.id, "row"))) {
                    g = node;
                } else {
                }
                if (g) {
                    d3.select(g)
                        .selectAll("path")
                        .each(function() {
                            //                        d.tester = d3.select(this.parentNode).data()[0].tester
                            self.pathColor(d, this, d3.select(node), true);
                        });
                }
            }

            if (this.circleClone !== null) {
                this.circleClone.parentNode.removeChild(this.circleClone);
                this.circleClone = null;
            }
        },
        // RECHERCHE METHODS
        clearFilters() {
            this._.forEach(this.products, (composant, key) => {
                this.products[key].active = false;
            });
            bus.$emit("resetFilters", "");
        },
        reset() {
            this.search = "";
            this.$router.push({ name: "Plano" });
            bus.$emit("resetSearch", "");
            d3.select("#shadesContent")
                .selectAll("*")
                .remove();
            this.shades = [];
            this.loadShades(this.relProductId);
        },
        submit() {
            d3.select("#shadesContent")
                .selectAll("*")
                .remove();
            this.shades = [];
            this.loadShades(this.relProductId);
        },
        searchShade() {
            d3.select("#shadesContent")
                .selectAll("*")
                .remove();
            this.displayShade();
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                temp[key] = this.$route.query[key];
            }
            if (x.hasOwnProperty("product")) {
                delete temp.offset;
            }
            for (let key in x) {
                temp[key] = x[key];
            }
            return temp;
        },
        setRouteParams(params) {
            let temp = {};
            for (let key in params) {
                if (key !== "url" && key !== "method") {
                    temp[key] = params[key];
                }
            }
            this.routeParams = temp;
        },
        updateQuery(to) {
            this.setRouteParams(to.query);
            this.loading = !this.loading;
            this.$store.dispatch("plano/data/getRelatedShades", { id: this.relProductId }).then(() => {
                this.updateVueResults(this.getRelatedShades);
                this.getQueryShades;
                this.loading = false;
            });
        },
        updateVueResults(datas) {
            this.searchResults = datas;
        },
        activeProduct(index, id) {
            this.productActive = index;
            d3.select("#shadesContent")
                .selectAll("*")
                .remove();
            this.shades = [];
            this.loadShades(id);
        },
        setVueFilters() {
            this.setVueFiltersProduct();
        },
        setVueFiltersProduct() {
            let routeParams = this.getRouteParams();
            this._.forEach(this.getFilters("product"), (product, key) => {
                if (typeof routeParams.product !== "undefined" && parseInt(key) === routeParams.product) {
                    product.active = true;
                } else {
                    product.active = false;
                }
                this.product[key] = product;
            });
        },
        getRouteParams() {
            return this._.omitBy(this.routeParams, (o, key) => {
                return key === "offset" && o === 1;
            });
        }
    },
    computed: {
        ...mapGetters({
            getSvg: "plano/status/getSvg",
            getSvgDimensions: "plano/status/getSvgDimensions",
            getModulesSvg: "plano/status/getModulesSvg",
            getGroups: "plano/status/getGroups",
            getRelatedShades: "plano/data/getRelatedShades",
            getQueryShades: "plano/data/getQueryShades"
        }),
        retSvg() {
            return this.$store.state.plano.status.builder.svg;
        },
        retMode() {
            return this.$store.state.plano.status.builder.mode;
        },
        retRelatedProduct() {
            return this.$store.state.plano.data.relatedProducts;
        },
        retGroups() {
            return this.$store.state.plano.status.builder.groups;
        },
        getVueResults() {
            return this.$data.searchResults;
        },
        filteredShades() {
            let self = this;
            return this.shades.filter(function(shade) {
                var filterMatch;
                if (shade.name !== undefined) {
                    filterMatch = shade.name.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                } else {
                    filterMatch = shade.nameBis.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                }

                if (shade.ref !== undefined) {
                    filterMatch = filterMatch || shade.ref.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                }

                if (shade.refClient !== undefined) {
                    filterMatch = filterMatch || shade.refClient.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
                }

                return filterMatch;
            });
        }
    },
    mounted() {},
    created() {
        let moduleEdit = this.getModulesEdit[0];

        this.products = this.getRelatedProducts(moduleEdit.id);
        this.relProductId = Object.keys(this.products)[0];
        this.loadShades(this.relProductId);
        if (i18n.locale === "fr") {
            this.noShades = "désolé, aucune teinte disponible";
        } else {
            this.noShades = "sorry, no shades available";
        }
    }
};
</script>
<style lang="scss" scoped>
.shadeCircle {
    border: 1px solid #000;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0;
}

#shadesWrapper {
    width: 350px;
}

#contentMenu {
    z-index: 1;
    background: #fff;
    height: calc(100vh - 105px);

    #searchInputWrapper {
        padding: 15px;
        border-bottom: 1px solid #f4f4f4;
        #searchInput {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        #cross {
            position: relative;
            right: 15px;
        }
    }
    #filtersShades {
        height: calc(100% - 61px);
        padding: 15px;
        #relatedProducts {
            padding: 0;
            li {
                margin: 0 5px;
                padding-bottom: 5px;
                border-bottom: 1px solid #343434;
                &.active {
                    border-width: 2px;
                }
            }
        }
        #spinnerLoader {
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.7);
            z-index: 10;
            top: 0;
            left: 0;
            .loader {
                margin: auto;
            }
        }
        #shadesContent {
            height: inherit;
        }
    }
    #resultsWrapper {
        padding: 15px 15px 0px 15px;
        overflow-y: scroll;
        max-height: calc(100vh - 320px);
        .item {
            font-size: 12px;
            &.firstRow,
            &.secondRow {
                margin-bottom: 20px;
            }
            &.bordered {
                border-right: 1px solid #ccc;
            }
            .svgMeuble {
                padding: 15px;
            }
            h3 {
                padding: 0 15px;
            }
            figure {
                max-width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// MenuShades.vue?2889a812